import { useMemo } from 'react';

import { useConvertLoyaltyPoints, useGetCompPointsConversionDetails, useGetDynamicBalances } from 'server';

export const useWalletPublicAPI = () => {
    const convertLoyaltyPoints = useConvertLoyaltyPoints();
    const getCompPointsConversionDetails = useGetCompPointsConversionDetails();
    const getDynamicBalances = useGetDynamicBalances();

    return useMemo(() => ({
        /**
         *
         * @memberOf Playtech.API.wallet
         * @function
         * @returns {Promise<{}>}
         * @example
         * Playtech.API.wallet.convertLoyaltyPoints();
         */
        convertLoyaltyPoints,
        /**
         *
         * @memberOf Playtech.API.wallet
         * @function
         * @returns {Promise<{}>}
         * @example
         * Playtech.API.wallet.getCompPointsConversionDetails();
         */
        getCompPointsConversionDetails,
        /**
         *
         * @memberOf Playtech.API.wallet
         * @function
         * @param params Object
         * @param params.balanceTypes {Array<String>}
         * @param [params.clientType] {String}
         * @param [params.clientPlatform] {String}
         * @param [params.languageCode] {String}
         * @returns {Promise<{balances: Array<{balanceType: String, balance: {amount: String, currencyCode: String}}>}>}
         * @example
         * Playtech.API.wallet.getDynamicBalances({ balanceTypes: ['real_gaming_balance'] });
         */
        getDynamicBalances
    }), [
        convertLoyaltyPoints,
        getCompPointsConversionDetails,
        getDynamicBalances
    ]);
};
